import createEnum from 'lib/createEnum';

export const SUB_TYPES = createEnum('FILE', 'IMAGE', 'TEXT', 'SESSION_END', 'URL');

export default {
  SUB_TYPES,
};
